if(!customElements.get('collection-product-grid-info')) {
    customElements.define('collection-product-grid-info', 
        class collectionProductGridInfo extends HTMLElement {
            onVariantChangeUnsubscriber = undefined;
            constructor() {
                super();
                this.atcBtn = this.querySelector('button[type="submit"][name="add"]')
                this.atcBtnText = this.querySelector('button[type="submit"][name="add"] span')
                this.soldoutBtn = this.querySelector('button[type="submit"][name="add"] .sold-out-message')
            }
 
            connectedCallback() {
                this.onVariantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.customProductInfoVariantChange,
                    this.handleOptionValues.bind(this)
                )
            }
            handleOptionValues(evt) {
                const data =evt.data
                const {event, selectedOptionValues, target }  = data
                if (!this.contains(event.target)) return;

                const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
                this.classList.add('disabled')
                this.pendingRequestUrl = productUrl;
                const shouldSwapProduct = this.dataset.url !== productUrl;
                const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

                this.renderProductInfo({
                    requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
                    targetId: target.id,
                    callback: shouldSwapProduct
                    ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
                    : this.handleUpdateProductInfo(productUrl),
                });
                
            }

            buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
                const params = [];
                if (optionValues.length) {
                  params.push(`option_values=${optionValues.join(',')}`);
                }
        
                return `${url}?${params.join('&')}`;
            }
            renderProductInfo({ requestUrl, targetId, callback }) {
              fetch(requestUrl)
                .then((response) => response.text())
                .then((responseText) => {
                  this.pendingRequestUrl = null;
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  callback(html);
                })
                .then((xyz) => {
                  // set focus to last clicked option value
                  document.querySelector(`#${targetId}`)?.focus();
                })
                .catch((error) => {
                  if (error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                  } else {
                    console.error(error);
                  }
                });
            }
            getSelectedVariant(productInfoNode) {
              const selectedVariant = productInfoNode.body.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
              return !!selectedVariant ? JSON.parse(selectedVariant) : null;
            }    
            handleSwapProduct(productUrl, updateFullPage) {
                return (html) => {
                  this.productModal?.remove();
                  const selector = updateFullPage ? "bundle-product-info[id^='MainProduct']" : 'bundle-product-info';

                  const variant = this.getSelectedVariant(html.querySelector(selector));

                  if (updateFullPage) {
                    document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
        
                    HTMLUpdateUtility.viewTransition(
                      document.querySelector('main'),
                      html.querySelector('main'),
                      this.preProcessHtmlCallbacks,
                      this.postProcessHtmlCallbacks
                    );
                  } else {
                    HTMLUpdateUtility.viewTransition(
                      this,
                      html.querySelector('bundle-product-info'),
                      this.preProcessHtmlCallbacks,
                      this.postProcessHtmlCallbacks
                    );
                  }
                  if(this.classList.contains('disabled')) {
                    this.classList.remove('disabled')
                  }

                };
              }

            get variantSelectors() {
                return this.querySelector('variant-selects [data-selected-variant]');
            }
    

            updateOptionValues(html) {
            const variantSelects = html.querySelector('variant-selects [data-selected-variant]');
            if (variantSelects) {
                HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
            }
            }
            handleUpdateProductInfo(productUrl) {
                return (html) => {
                const variant = this.getSelectedVariant(html);

                this.pickupAvailability?.update(variant);
                this.updateOptionValues(html);
                this.updateVariantInputs(variant?.id);
      
                if (!variant) {
                  this.setUnavailable();
                  return;
                }
    
                if(variant.available) {
                    this.atcBtn.removeAttribute('disabled')
                    this.atcBtnText.classList.contains('hidden') ? this.atcBtnText.classList.remove('hidden') : ''
                    if(!this.soldoutBtn.classList.contains('hidden')) {
                        this.soldoutBtn.classList.add('hidden')
                    }

                } else {
                    this.atcBtn.setAttribute('disabled', 'disabled')
                    if(this.soldoutBtn.classList.contains('hidden')) {
                        this.atcBtnText.classList.add('hidden')
                        this.soldoutBtn.classList.remove('hidden')
                    }
                }
    
                // form id update
                this.querySelector('form input.product-variant-id').value = variant.id 
                const button = this.querySelector('form button[name="buy-now"]');
                const buyAttr = button.getAttribute("onclick");
                if (buyAttr) {
                  // Extract the function name and ID using regex
                  const updatedAttr = buyAttr.replace(/\d+/, variant.id); // Replace the number in parentheses
                  button.setAttribute("onclick", updatedAttr); // Update the onclick attribute
                  console.log("Updated onclick:", button.getAttribute("onclick"));
                } else {
                  console.error("The button does not have an onclick attribute.");
                }
                // update price
                this.querySelector('.price .price__container').replaceWith(html.querySelector('.price .price__container'))

                if(this.classList.contains('disabled')) {
                    this.classList.remove('disabled')
                }
      
                publish(PUB_SUB_EVENTS.variantChange, {
                  data: {
                    sectionId: this.sectionId,
                    html,
                    variant,
                  },
                });
              };
            }
            updateVariantInputs(variantId) {
                this.querySelectorAll(
                  `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
                ).forEach((productForm) => {
                  const input = productForm.querySelector('input[name="id"]');
                  input.value = variantId ?? '';
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                });
            }
        
            updateVariantInputs(variantId) {
              this.querySelectorAll(
                `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
              ).forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = variantId ?? '';
                input.dispatchEvent(new Event('change', { bubbles: true }));
              });
            }
            
            disconnectedCallback() {
                this.onVariantChangeUnsubscriber();
            }  
        }
    )
}